import React, { PureComponent } from "react";
import _ from "lodash";
import {
  Card,
  CardBody,
  Col,
  Button,
  ButtonToolbar,
  Container,
  Row,
  Table,
  Modal,
} from "reactstrap";
import { Field, reduxForm } from "redux-form";
import "./styles.css";
import EyeIcon from "mdi-react/EyeIcon";
import EmailIcon from "mdi-react/EmailIcon";
import AccountSearchIcon from "mdi-react/AccountSearchIcon";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import renderFileInputField from "../../../../shared/components/form/FileInput";
import renderSelectField from "../../../../shared/components/form/Select";
import renderMultiSelectField from "../../../../shared/components/form/MultiSelect";
import $ from "jquery";
import readXlsxFile, { Integer } from "read-excel-file";
import XLSX from "xlsx";
import { make_cols } from "./MakeColumns";
import { SheetJSFT } from "./types";
import Sheet from "../../../../images/BIN_MASTER_v1.xlsx";
import axios from "axios";
import Select from "react-select";
import { MDBDataTable } from "mdbreact";
import * as FileSaver from "file-saver";
import LoadingOverlay from 'react-loading-overlay';
import Util from '../../../Common/util';
import API from '../../../Common/api';

import "./styles.css";
/*import Modal from '../../../../shared/components/Modal';*/
import { addAnalytics, paginationAnalytics } from '../../../Common/analytics';
import exportToCSVNew from '../../../Common/exportcsvnew';


var url = window.location.hostname;
var port = window.location.port;




class HorizontalForm extends PureComponent {
  static propTypes = {
    t: PropTypes.func.isRequired,
    //handleSubmit: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
  };

  constructor() {
    super();
    this.handleChange = this.handleChange.bind(this);
    this.handleFile = this.handleFile.bind(this);
    this.change = this.change.bind(this);
    this.toggle = this.toggle.bind(this);
    this.toggleFailed = this.toggleFailed.bind(this);
    this.togglePressCancel = this.togglePressCancel.bind(this);
    this.Successtoggle = this.Successtoggle.bind(this);
    this.SuccesstoggleCancel = this.SuccesstoggleCancel.bind(this);
    this.ConfirmToggle = this.ConfirmToggle.bind(this);
    this.openConfirm = this.openConfirm.bind(this);

    /*this.onMasterChange = this.onMasterChange.bind(this);*/

    this.state = {
      loading_overlay: false,
      basepack_header: [
        { "Sku": "", "BASE_PACK_CODE": "", "PRODUCT_NAME": "", "Unit/Case ( Units)": "", "MRP": "", "Product Sub Division": "", "Product Category": "", "Sub Category": "", "Sub-Putaway Group": "", "SKU Weight": "", "SKU Volume": "", "Carton Weight (KGs)": "", "Carton Length (FT)": "", "Carton Breadth (FT)": "", "Carton Height (FT)": "", "Carton Volume (CFT)": "", "Inner Length": "", "Inner Breadth": "", "Inner Height": "", "Author uid": "", "Created Date": "", "Brand": "", "Shelf Life (Months)": "", "MRSL(%)": "", "Fragile Item" : "" },
      ],

      showPassword: false,
      responseModal: false,
      responseModalMsg: null,
      btnDisabled: false,
      file: {},
      data: [],
      cols: [],
      dummyFile: {},
      showInvalidItem: false,
      loadingGRNData: false,
      showInvalidBaseItem: false,
      showInvalidProductItem: false,
      fileNameVal: "masterFile",
      showResponseData: false,
      showBaseResponseData: false,
      showProductResponseData: false,
      responseUpdatedBaseData: false,
      responseUpdatedProductData: false,
      showRowDataError: false,
      invalidItemList: [],
      selectedOption: null,
      postsBase: [],
      tableRowsBase: [],
      ErrorRowData: [],
      modal: false,
      modalFailed: false,
      ConfirmModal: false,
      Successmodal: false,
      loading: false,
      isLoading: true,
      showFetchBaseData: false,
      show_process_data: true,
      tableRows: [],
      value: "",
      error: "",
      value: "select",
      selectedFileType: "",
      responseFailProductData: []
    };
  }

  showPassword = (e) => {
    e.preventDefault();
    this.setState((prevState) => ({ showPassword: !prevState.showPassword }));
  };

  responseModalToggle = () => {
    this.setState({
      responseModal: !this.state.responseModal
    });
  }


  componentWillMount() {
    if (window.location.port == 8091 || window.location.port === ":8090") {
      port = ":8090";
    } else if (window.location.port == 8098 || window.location.port === ":8098") {
      port = ":8099";
    } else {
      port = ":8088";
    }

    if (url === "localhost") {
      url = "15.206.34.41" + ":8088";
    } else {
      url = window.location.hostname + port;
    }

    var cookieUsername = Util.getCookie("token");
    var location = Util.getCookie("selectedLocation");
    var username = Util.accessCookie("token");
    this.setState(
      {
        userName: cookieUsername,
        selectedLocation: location,
      },
      () => {
        //this.config_zoneDropDown();
        //this.zoneDropdown();
      }
    );

    localStorage.setItem("userName", username);
  }

  SuccesstoggleCancel() {
    this.setState(
      {
        Successmodal: false,
      }/*,
      () => {
        if (document.getElementById("my_file_input") !== null) {
          document.getElementById("my_file_input").style.color = "transparent";
          document.getElementById("tester_label").style.display =
            "inline-block";
          document.getElementById("tester_label").innerHTML =
            "Select and Upload Master ";
      document.getElementById("my_file_input").style.width = "26%";
        }
        $(".upload_error").css("display", "none");
        $(".upload_success").css("display", "none");
      }*/
    );

    /*if (this.state.selectedOption.value === "bin_master") {
          this.fetchBinData();
          

      } else if (this.state.selectedOption.value === "base_pack_zone") {
          this.fetchBaseData();
          

      } else if (this.state.selectedOption.value === "product_master") {
          this.fetchProductData();
          

      }*/
  }

  toggle() {
    this.setState((prevState) => ({ modal: !prevState.modal }));
  }

  Successtoggle() {
    this.setState((prevState) => ({ Successmodal: !prevState.Successmodal }));
  }

  toggleFailed() {
    this.setState((prevState) => ({ modalFailed: !prevState.modalFailed }));
  }

  ConfirmToggle() {
    this.setState((prevState) => ({ ConfirmModal: !prevState.ConfirmModal }));
  }

  openConfirm() {
    this.setState({
      ConfirmModal: true,
    });
  }

  togglePressCancel() {

    this.setState({
      modal: false,
      modalFailed: false,
    });
  }

  handleChange(evt) {
    const files = evt.target.files;
    var file1 = evt.target.value;
    this.setState({
      btnDisabled: true,
      loading_overlay: true,
    }, () => {

      if (files && files[0]) {
        this.setState({
          file: files[0]
        })
      } else {
        this.setState({
          loading_overlay: false,
          btnDisabled: false,
          file: {},
        })
        $(".upload_success").css('display', 'none');
        $(".upload_error").css('display', 'none');
        $('.button_enable').removeAttr('disabled', 'disabled');
        return false;
      };

      var fileArray1 = file1.split(".");
      var extension1 = fileArray1[fileArray1.length - 1];

      if (document.getElementById("my_file_input") !== null) {
        document.getElementById("my_file_input").style.color = "";
        document.getElementById("my_file_input").style.width = "85%";
        document.getElementById("picking_label").style.display = "none";
      } else {
        document.getElementById("my_file_input").style.width = "26%";
      }

      if (extension1 != "xlsx" && extension1 != "csv" && extension1 != "xls") {
        $(".upload_error").css("display", "block");
        $(".upload_success").css("display", "none");
      } else {
        $(".upload_success").css("display", "block");
        $(".upload_error").css("display", "none");
        $(".button_enable").removeAttr("disabled", "disabled");
      }

      this.setState({
        btnDisabled: false,
        loading_overlay: false,
      });
    });
  }

  change = (selectedOption) => {
    this.setState({
      selectedOption,
      selectedFileType: selectedOption.label,
      showInvalidProductItem: false,
      showInvalidTesterItem: false,
      showRowDataErrorProduct: false,
      showRowDataErrorTester: false,
      showInvalidBaseItem: false,
      showRowDataErrorBase: false,
      showRowDataError: false,
      showInvalidItem: false,
      showZoneConfigCard: false,
    });
    $(".upload_error").css("display", "none");
    $(".upload_success").css("display", "none");
    $(".fileControl").val("");

    if (selectedOption.value === "bin_master") {
      //this.fetchBinData();
      this.setState({
        showFetchBinData: true,
        showFetchBaseData: false,
        showFetchTesterData: false,
        showFetchProductData: false,
      });
    } else if (selectedOption.value === "base_pack_zone") {
      //this.fetchBaseData();
      this.setState({
        showFetchBinData: false,
        showFetchBaseData: true,
        showFetchProductData: false,
        showFetchTesterData: false,
        showZoneConfigCard: true
      });
    } else if (selectedOption.value === "product_master") {
      //this.fetchProductData();
      this.setState({
        showFetchBinData: false,
        showFetchBaseData: false,
        showFetchProductData: true,
        showFetchTesterData: false,
      });
    } else if (selectedOption.value === "tester_basepack_master") {
      //this.fetchTesterData();
      this.setState({
        showFetchBinData: false,
        showFetchBaseData: false,
        showFetchProductData: false,
        showFetchTesterData: true,
      });
    }
  };

  validateItem = (item) => {
    const { selectedFileType, validation } = this.state;
    const dataTypes = validation[selectedFileType];
    if (dataTypes === undefined) {
      this.setState({
        error:
          "Invalid length of uploaded data. Below data are invalid. Please Upload a valid file format",
      });
      return false;
    }
    const keyNames = Object.keys(dataTypes);
    if (Object.keys(item).length !== keyNames.length) {
      this.setState({
        error:
          "Invalid length of uploaded data. Below data are invalid. Please Upload a valid file format",
      });
      return false;
    }

    return true;
  };


  handleFile() {
    /* Boilerplate to set up FileReader */

    if (this.state.file.name === undefined || this.state.file.name === null) {
      this.setState({
        responseModal: true,
        responseModalMsg: "Select at least one File"
      });
      return false;
    }
    this.setState({
      loading: true,
      loading_overlay: true,
    });
    const ref = this;
    const reader = new FileReader();
    const rABS = !!reader.readAsBinaryString;

    reader.onload = (e) => {
      /* Parse data */
      const bstr = e.target.result;
      const wb = XLSX.read(bstr, {
        type: rABS ? "binary" : "array",
        bookVBA: true,
      });
      /* Get first worksheet */
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      /* Convert array of arrays */
      const data = XLSX.utils.sheet_to_json(ws, {
        raw: false,
        dateNf: "YYYY-MM-DD"
      });

      var XL_row_object = XLSX.utils.sheet_to_row_object_array(
        wb.Sheets[wsname],
        { header: 1, blankRows: false }
      );
      var json_object = XL_row_object;


      var mandatory_field = false;
      var uploaded_file_header = json_object[0];

      var sample_file_header = Object.keys(this.state.basepack_header[0]);

      if (parseInt(uploaded_file_header.length) !== parseInt(sample_file_header.length)) {
        ref.setState({
          loading: false,
          responseModal: true,
          responseModalMsg: "Invalid Format",
          loading_overlay: false,
        });

        return false;
      }
      this.setState({ data: data, cols: make_cols(ws["!ref"]) }, () => {
        let invalidItems = []
        if (invalidItems.length > 0) {
          this.setState({
            showRowDataErrorBase: false,
            showRowDataErrorProduct: false,
            showRowDataErrorTester: false,
            showRowDataError: false,
            showResponseData: true,
            ErrorRowData: invalidItems,
            showResponseData: false,
            showInvalidItem: false,
            showBaseResponseData: false,
            showInvalidBaseItem: false,
            showInvalidProductItem: false,
            showInvalidTesterItem: false,
            showProductResponseData: false,
            showFetchBaseData: false,
            showFetchProductData: false,
            showFetchTesterData: false,
            showFetchBinData: false,
          });

        }

        addAnalytics('Upload File', 'Upload SKU7', this.state.data);
        var arr = [];
        var invalid_data = []

        for (var i = 0; i < this.state.data.length; i++) {
          // <---- Move declaration inside loop

          var orderData = {};

          if (this.state.data[i]["Sku"] == undefined || this.state.data[i]["Sku"] == null) {
            orderData["sku"] = "";
          } else {
            orderData["sku"] = this.state.data[i]["Sku"];
          }

          if (this.state.data[i]["BASE_PACK_CODE"] == undefined || this.state.data[i]["BASE_PACK_CODE"] == null) {
            orderData["base_pack_code"] = "";
          } else {
            orderData["base_pack_code"] = this.state.data[i]["BASE_PACK_CODE"];
          }

          if (this.state.data[i]["PRODUCT_NAME"] == undefined || this.state.data[i]["PRODUCT_NAME"] == null) {
            orderData["product_name"] = "";
          } else {
            orderData["product_name"] = this.state.data[i]["PRODUCT_NAME"];
          }

          if (this.state.data[i]["Unit/Case ( Units)"] == undefined || this.state.data[i]["Unit/Case ( Units)"] == null) {
            orderData["unit"] = "";
          } else {
            orderData["unit"] = this.state.data[i]["Unit/Case ( Units)"];
          }

          if (this.state.data[i]["MRP"] == undefined || this.state.data[i]["MRP"] == null) {
            orderData["mrp"] = "";
          } else {
            orderData["mrp"] = this.state.data[i]["MRP"];
          }

          if (this.state.data[i]["Product Sub Division"] == undefined || this.state.data[i]["Product Sub Division"] == null) {
            orderData["sub_division"] = "";
          } else {
            orderData["sub_division"] = this.state.data[i]["Product Sub Division"];
          }

          if (this.state.data[i]["Product Category"] == undefined || this.state.data[i]["Product Category"] == null) {
            orderData["product_category"] = "";
          } else {
            orderData["product_category"] = this.state.data[i]["Product Category"];
          }

          if (this.state.data[i]["Sub Category"] == undefined || this.state.data[i]["Sub Category"] == null) {
            orderData["sub_category"] = "";
          } else {
            orderData["sub_category"] = this.state.data[i]["Sub Category"];
          }

          if (this.state.data[i]["Sub-Putaway Group"] == undefined || this.state.data[i]["Sub-Putaway Group"] == null) {
            orderData["sub_putaway_group"] = "";
          } else {
            orderData["sub_putaway_group"] = this.state.data[i]["Sub-Putaway Group"];
          }

          if (this.state.data[i]["SKU Weight"] == undefined || this.state.data[i]["SKU Weight"] == null) {
            orderData["sku_weight"] = "";
          } else {
            orderData["sku_weight"] = this.state.data[i]["SKU Weight"];
          }

          if (this.state.data[i]["SKU Volume"] == undefined || this.state.data[i]["SKU Volume"] == null) {
            orderData["sku_volume"] = "";
          } else {
            orderData["sku_volume"] = this.state.data[i]["SKU Volume"];
          }

          if (this.state.data[i]["Carton Weight (KGs)"] == undefined || this.state.data[i]["Carton Weight (KGs)"] == null) {
            orderData["carton_weight"] = "";
          } else {
            orderData["carton_weight"] = this.state.data[i]["Carton Weight (KGs)"];
          }

          if (this.state.data[i]["Carton Length (FT)"] == undefined || this.state.data[i]["Carton Length (FT)"] == null) {
            orderData["carton_length"] = "";
          } else {
            orderData["carton_length"] = this.state.data[i]["Carton Length (FT)"];
          }

          if (this.state.data[i]["Carton Breadth (FT)"] == undefined || this.state.data[i]["Carton Breadth (FT)"] == null) {
            orderData["carton_breadth"] = "";
          } else {
            orderData["carton_breadth"] = this.state.data[i]["Carton Breadth (FT)"];
          }

          if (this.state.data[i]["Carton Height (FT)"] == undefined || this.state.data[i]["Carton Height (FT)"] == null) {
            orderData["carton_height"] = "";
          } else {
            orderData["carton_height"] = this.state.data[i]["Carton Height (FT)"];
          }

          if (this.state.data[i]["Carton Volume (CFT)"] == undefined || this.state.data[i]["Carton Volume (CFT)"] == null) {
            orderData["carton_volume"] = "";
          } else {
            orderData["carton_volume"] = this.state.data[i]["Carton Volume (CFT)"];
          }
          if (this.state.data[i]["Inner Length"] == undefined || this.state.data[i]["Inner Length"] == null) {
            orderData["inner_length"] = "";
          }
          else if (isNaN(parseInt(this.state.data[i]["Inner Length"], 10)) && this.state.data[i]["Inner Length"] != "") {
            invalid_data.push({ "sku": this.state.data[i]["Sku"] + "-" + this.state.data[i]["MRP"], "message": this.state.data[i]["Inner Length"] + " Must be Integer", "success": false })
          }
          else {
            orderData["inner_length"] = parseInt(this.state.data[i]["Inner Length"], 10);
          }
          if (this.state.data[i]["Inner Breadth"] == undefined || this.state.data[i]["Inner Breadth"] == null) {
            orderData["inner_breadth"] = "";
          }
          else if (isNaN(parseInt(this.state.data[i]["Inner Breadth"], 10)) && this.state.data[i]["Inner Breadth"] != "") {
            invalid_data.push({ "sku": this.state.data[i]["Sku"] + "-" + this.state.data[i]["MRP"], "message": this.state.data[i]["Inner Breadth"] + " Must be Integer", "success": false })
          }
          else {
            orderData["inner_breadth"] = parseInt(this.state.data[i]["Inner Breadth"], 10);
          }
          if (this.state.data[i]["Inner Height"] == undefined || this.state.data[i]["Inner Height"] == null) {
            orderData["inner_height"] = "";
          }
          else if (isNaN(parseInt(this.state.data[i]["Inner Height"], 10)) && this.state.data[i]["Inner Height"] != "") {
            invalid_data.push({ "sku": this.state.data[i]["Sku"] + "-" + this.state.data[i]["MRP"], "message": this.state.data[i]["Inner Height"] + " Must be Integer", "success": false })
          }
          else {
            orderData["inner_height"] = parseInt(this.state.data[i]["Inner Height"], 10);
          }

          if (this.state.data[i]["Author uid"] == undefined || this.state.data[i]["Author uid"] == null) {
            orderData["author_uid"] = "";
          } else {
            orderData["author_uid"] = this.state.data[i]["Author uid"];
          }

          if (this.state.data[i]["Created Date"] == undefined || this.state.data[i]["Created Date"] == null) {
            orderData["created_date"] = "";
          } else {
            orderData["created_date"] = this.state.data[i]["Created Date"];
          }

          if (this.state.data[i]["Brand"] == undefined || this.state.data[i]["Brand"] == null) {
            orderData["brand"] = "";
          } else {
            orderData["brand"] = this.state.data[i]["Brand"];
          }
          if (this.state.data[i]["Shelf Life (Months)"] == undefined || this.state.data[i]["Shelf Life (Months)"] == null) {
            orderData["shelf_life"] = "";
          }
          else if (isNaN(parseInt(this.state.data[i]["Shelf Life (Months)"], 10)) && this.state.data[i]["Shelf Life (Months)"] != "") {
            invalid_data.push({ "sku": this.state.data[i]["Sku"] + "-" + this.state.data[i]["MRP"], "message": this.state.data[i]["Shelf Life (Months)"] + " Must be Integer", "success": false })
          }
          else {
            orderData["shelf_life"] = parseInt(this.state.data[i]["Shelf Life (Months)"], 10);
          }
          if (this.state.data[i]["MRSL(%)"] == undefined || this.state.data[i]["MRSL(%)"] == null) {
            orderData["mrsl"] = "";
          }
          else if (isNaN(parseInt(this.state.data[i]["MRSL(%)"], 10)) && this.state.data[i]["MRSL(%)"] != "") {
            invalid_data.push({ "sku": this.state.data[i]["Sku"] + "-" + this.state.data[i]["MRP"], "message": this.state.data[i]["MRSL(%)"] + " Must be Integer", "success": false })
          }
          else {
            orderData["mrsl"] = parseInt(this.state.data[i]["MRSL(%)"], 10);
          }

           if (this.state.data[i]["Fragile Item"] == undefined || this.state.data[i]["Fragile Item"] == null) {
            orderData["fragile"] = "";
          } else {
            orderData["fragile"] = this.state.data[i]["Fragile Item"];
          }

          arr.push(orderData);
        }

        var arr_data = JSON.stringify(arr);
        if (invalid_data.length > 0) {
          this.toggleFailed();
          this.setState({
            showInvalidProductItem: true,
            responseFailProductData: invalid_data,
            loading: false,
            loading_overlay: false
          })

        }
        else {
          const payload = {
            master_data: arr,
            master_type: "sku7_master",

          };

          API.post("/jogeshwari/upload/v1/", { param: payload })
            .then((response) => {
              this.setState({
                showBaseResponseData: true,
                showInvalidBaseItem: false,
                showInvalidTesterItem: false,
                showTesterResponseData: false,
                loading: false,
                showResponseData: false,
                showInvalidItem: false,
                showProductResponseData: false,
                //showInvalidProductItem: false,
                showRowDataError: false,
                showRowDataErrorBase: false,
                showRowDataErrorProduct: false,
                showInvalidProductItem: true,
                responseFailProductData: response.data.data,
                showRowDataErrorTester: false,
                responseFailBaseData: response.data,
                responseSuccessBaseData: response.data,
                show_process_data: true,
              });

              if (response.data.success == false) {
                this.toggleFailed();
              } else {
                this.Successtoggle();
                this.setState({
                  successCreatedMessage: response.data.message
                })
              }

              this.setState({ loading_overlay: false, })
              if (document.getElementById("my_file_input") !== null) {
                document.getElementById("my_file_input").style.color =
                  "transparent";
                document.getElementById("picking_label").style.display = "inline-block";
                document.getElementById("picking_label").innerHTML =
                  "Select and Upload SKU7 Master";
              }
              document.getElementById("my_file_input").style.width = "26%";
              $(".upload_error").css('display', 'none');
              $(".upload_success").css('display', 'none');
              /*this.fetchBaseData();*/
            })
            
             .catch((error) => {
            this.setState({
              loading_overlay: false,
              loading: false,
            });

            // Check if the error is a 400 error
            if (error.response && error.response.status === 400) {
              // Handle 400 error and display the message in the modal
              
              const errorMessage = error.response.data.reason || "An error occurred during the upload.";
              this.setState({
                responseModal: true,
                responseModalMsg: errorMessage, // Display the error message
              });
            } else {
              // General error handling
              this.setState({
                responseModal: true,
                responseModalMsg: "An unexpected error occurred. Please try again.",
              });
            }
            
          });
      }
    });
  };

      

    if (rABS) {
      reader.readAsBinaryString(this.state.file);
    } else {
      reader.readAsArrayBuffer(this.state.file);
    }
  }


  render() {
    const { handleSubmit, reset, t } = this.props;
    const { showPassword } = this.state;
    const { selectedOption } = this.state;
    const { modal } = this.state;
    const { modalFailed } = this.state;
    const { Successmodal } = this.state;
    const { ConfirmModal } = this.state;


    return (

      <Col xl={12}>
        {/*<div class="overlay">
    <div class="overlay__inner">
      <div class="overlay__content"><span class="spinner"></span></div>
    </div>
      </div>*/}
        {this.state.loading_overlay && <LoadingOverlay active={true} spinner text='' />}
        <Card>
          <CardBody style={{ height: 220 }}>
            <div className="card__title">
              <h5 className="bold-text"></h5>
            </div>
            <form className="form form--inline" onSubmit={e => e.preventDefault()}>
              <div
                className="form__form-group col-xl-5"
                style={{ marginBottom: "0px" }}
              >
                <div className="row">
                  <div
                    className="col-xl-12"
                    style={{ border: "1px solid #f2f4f7" }}
                  >
                    <input
                      style={{
                        paddingTop: 8,
                        height: 38,
                        color: "transparent",
                        width: "26%",
                        border: "0px",
                      }}
                      name="defaultInput"
                      component="input"
                      type="file"
                      placeholder="Default Input"

                      id="my_file_input"
                      onChange={this.handleChange}
                      ref={ref => this.fileInput = ref}
                    />
                    <label for="files" id="picking_label">
                      Select and Upload SKU7 Master
                    </label>
                  </div>
                  <div className="col-xl-12">
                    <span
                      style={{ display: "none", color: "red" }}
                      className="upload_error"
                    >
                      {" "}
                      Invalid file format. Please select .xls, .xlsx, .csv file
                      format{" "}
                    </span>
                    <span
                      style={{ display: "none", color: "green", marginTop: 8 }}
                      className="upload_success"
                    >
                      {" "}
                      Valid file format{" "}
                    </span>
                  </div>
                </div>
              </div>

              <div className="form__form-group col-xl-2">
                <ButtonToolbar className="form__button-toolbar">
                  <button
                    color="primary"
                    className="btn-sm button_enable "
                    style={{
                      fontWeight: "normal",
                      textTransform: "capitalize",
                      borderRadius: 5,
                      backgroundColor: "#70bbfd",
                      color: "#fff",
                      padding: "5px 25px",
                      fontSize: "14px",
                    }}
                    id="button_enable"
                    onClick={this.handleFile}
                    disabled={this.state.btnDisabled}
                  >
                    {this.state.loading && (
                      <i
                        className="fa fa-refresh fa-spin"
                        style={{ marginRight: "5px" }}
                      />
                    )}
                    Submit
                  </button>
                </ButtonToolbar>
              </div>
            </form>



            <div style={{ paddingLeft: "17px" }}>
              <button
                color="primary"
                className="download_sample_styling button_enable "
                style={{
                  backgroundColor: "#fff",
                  marginTop: 4,
                  marginBottom: 7,
                  fontWeight: "500",
                  textDecoration: "underline",
                  textTransform: "capitalize",
                }}
                onClick={(e) =>
                  exportToCSVNew(
                    this.state.basepack_header,
                    "SKU7_Master_Template"
                  )
                }
              >
                Sample Template
              </button>
              <div className="notes" style={{ paddingTop: "15px", display: 'none' }}>
                <p style={{ marginBottom: "13px", fontSize: "15px" }}>
                  <b>Note</b> : 1. All fields are mandatory.
                </p>
                <p
                  style={{
                    marginBottom: "13px",
                    fontSize: "15px",
                    paddingLeft: "46px",
                  }}
                >
                  2. Possible value for LB Type are (0, 2) : 0 = saleable, 2 =
                  Outer Cartons.
                </p>
                <p
                  style={{
                    marginBottom: "13px",
                    fontSize: "15px",
                    paddingLeft: "46px",
                  }}
                >
                  3. Make two separate entries : one for saleable and another
                  for outer carton for basepacks having OCLD Flag as "Yes" in
                  the Product Master.
                </p>
              </div>
            </div>
          </CardBody>

          {this.state.showInvalidProductItem && (
            <CardBody style={{ marginTop: 20 }}>

              <Table responsive className="table--bordered">
                <thead>
                  <tr>
                    <th>SKU</th>
                    <th>Response</th>
                  </tr>
                </thead>
                <tbody>
                  {this.state.responseFailProductData.length >
                    0 &&
                    this.state.responseFailProductData.map(
                      (item, index) => (
                        <tr>
                          <td>{item.sku}</td>
                          {item.success == false &&
                            <td style={{ color: "red" }}>{item.message}</td>
                          }
                          {item.success == true &&
                            <td style={{ color: "green" }}>{item.message}</td>
                          }
                        </tr>
                      )
                    )}

                </tbody>
              </Table>
            </CardBody>
          )}

        </Card>
        <Modal isOpen={modal} toggle={this.toggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>Successfully Validated </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.togglePressCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={modalFailed}
          toggle={this.toggleFailed}
          style={{ maxWidth: 578 }}
        >
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.toggleFailed}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-cross-circle modal__title-icon"
              style={{ color: "red" }}
            />
            <h4>This file contains some errors. </h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#ddd", color: "#fff" }}
              className="modal_ok"
              onClick={this.togglePressCancel}
            >
              Cancel
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal isOpen={Successmodal} toggle={this.Successtoggle}>
          <div className="modal__header">
            <button
              className="lnr lnr-cross modal__close-btn"
              type="button"
              style={{ right: 15 }}
              onClick={this.Successtoggle}
            />
          </div>
          <div
            className="modal__body"
            style={{ paddingTop: 55, paddingBottom: 20 }}
          >
            <span
              className="lnr lnr-thumbs-up modal__title-icon"
              style={{ color: "#4ce1b6" }}
            />
            <h4>Successfully Updated</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button
              style={{ backgroundColor: "#24d6a3", color: "#fff" }}
              className="modal_ok"
              onClick={this.SuccesstoggleCancel}
            >
              Ok
            </Button>
          </ButtonToolbar>
        </Modal>

        <Modal
          isOpen={this.state.responseModal}
          toggle={this.responseModalToggle}
        >
          <div className="modal__header">
            <button className="lnr lnr-cross modal__close-btn" type="button" style={{ right: 15 }} onClick={this.responseModalToggle} />


          </div>
          <div className="modal__body" style={{ paddingTop: 55, paddingBottom: 20 }}>
            <span className="lnr lnr-cross-circle modal__title-icon" style={{ color: 'red' }} />
            <h4>{this.state.responseModalMsg}</h4>
          </div>
          <ButtonToolbar className="modal__footer">
            <Button style={{ backgroundColor: '#ddd', color: '#fff' }} className="modal_ok" onClick={this.responseModalToggle}>Ok</Button>
          </ButtonToolbar>
        </Modal>


      </Col>
    );
  }
}

export default reduxForm({
  form: "Upload Master", // a unique identifier for this form
})(withTranslation("common")(HorizontalForm));